import type { OutcomeTone } from '../model/format';
import { Badge } from '@/shared/ui';
import { EMPTY_CELL, outcomeOf } from '../model/format';

const TONE_VARIANT = {
  success: 'active',
  warning: 'pending',
  muted: 'inactive',
  failure: 'error',
} as const satisfies Record<
  OutcomeTone,
  'active' | 'pending' | 'inactive' | 'error'
>;

type OutcomeBadgeProps = {
  outcome: string | null;
};

/** A session's outcome in plain words; the raw code stays on hover. */
export const OutcomeBadge = ({ outcome }: OutcomeBadgeProps) => {
  const shown = outcomeOf(outcome);
  if (!shown) return <>{EMPTY_CELL}</>;
  return (
    <Badge variant={TONE_VARIANT[shown.tone]} title={outcome ?? undefined}>
      {shown.label}
    </Badge>
  );
};
